<template>
  <base-page>
    <!-- <titlu-pagina Titlu="Setari" /> -->

    <el-row style="margin-bottom: 15px;">
      <el-col :span="24">
        <el-alert type="info" :closable="false" show-icon>
          <div slot="title" style="display: flex; gap: 20px; font-size: 14px; align-items: center;">
            <span style="font-weight: bold;">Status Cache programator:</span>
            <div style="display: flex; align-items: center; gap: 5px;">
              Mecanici: <el-tag size="mini" effect="dark" type="info" style="margin: 0px !important;">{{ cache_mecanici !== null ? `${cache_mecanici} ore` : '-' }}</el-tag>
            </div>
            <div>
              Pauze Mecanici: <el-tag size="mini" effect="dark" type="info" style="margin: 0px !important;">{{ cache_pauze_mecanici !== null ? `${cache_pauze_mecanici} ore` : '-' }}</el-tag>
            </div>
            <div>
              Program: <el-tag size="mini" effect="dark" type="info" style="margin: 0px !important;">{{ cache_program !== null ? `${cache_program} ore` : '-' }}</el-tag>
            </div>
          </div>
        </el-alert>
      </el-col>
    </el-row>

    <el-row class="main-page" :gutter="15">
      <el-col class="coloana" style="width:100% !important" :span="8">
        <el-card style='margin:5px 0px 5px 0px'>
          <div slot="header">
            <span>Program lucru</span>
            <el-button @click="save" style="float: right; padding: 6px 12px; " type="success" plain round size="large">
              Salveaza </el-button>
          </div>
          <el-form label-position="top" :model="Setari" :inline="false" :rules="rules" label-width="100%" ref='my-form'
            @submit.prevent="save" size="mini" style="padding:8px;">
            <!-- <el-row>
                            <el-form-item label='Interval minute afisare programari (in calendar)' prop="DurataProgramare">
                                <el-input-number class='full-width' v-model='Setari.DurataProgramare' :min="0" :step="5" />
                            </el-form-item>
                        </el-row> -->
            <el-row>
              <el-form-item label='Program luni - vineri'>
                <el-time-picker v-model="Setari.OraStartLV" placeholder="Ora incepere" format="HH:mm:00"
                  value-format="HH:mm:00" arrow-control />
                <el-time-picker v-model="Setari.OraStopLV" placeholder="Ora terminare" format="HH:mm:00"
                  value-format="HH:mm:00" arrow-control />
              </el-form-item>
            </el-row>
            <hr />
            <el-row>
              <el-form-item>
                <el-checkbox class="full-width" v-model="Setari.SeLucreazaS" true-label="1" false-label="0">
                  Program Sambata
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-time-picker :disabled="!Boolean(Number(this.Setari.SeLucreazaS))" v-model="Setari.OraStartS"
                  placeholder="Ora incepere" format="HH:mm:00" value-format="HH:mm:00" arrow-control />
                <el-time-picker :disabled="!Boolean(Number(this.Setari.SeLucreazaS))" v-model="Setari.OraStopS"
                  placeholder="Ora terminare" format="HH:mm:00" value-format="HH:mm:00" arrow-control />
              </el-form-item>
            </el-row>
            <el-row>
              <hr />
              <el-form-item>
                <el-checkbox class="full-width" v-model="Setari.SeLucreazaD" true-label="1" false-label="0">
                  Program Duminica
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-time-picker :disabled="!Boolean(Number(this.Setari.SeLucreazaD))" v-model="Setari.OraStartD"
                  placeholder="Ora incepere" format="HH:mm:00" value-format="HH:mm:00" arrow-control />
                <el-time-picker :disabled="!Boolean(Number(this.Setari.SeLucreazaD))" v-model="Setari.OraStopD"
                  placeholder="Ora terminare" format="HH:mm:00" value-format="HH:mm:00" arrow-control />
              </el-form-item>
            </el-row>
            <el-row>
              <hr />
              <el-form-item label='Program calendar'>
                <el-time-picker v-model="Setari.OraStartCalendar" placeholder="Ora incepere" format="HH:mm:00"
                  value-format="HH:mm:00" arrow-control />
                <el-time-picker v-model="Setari.OraStopCalendar" placeholder="Ora terminare" format="HH:mm:00"
                  value-format="HH:mm:00" arrow-control />
              </el-form-item>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
      <el-col class="coloana" style="width:100% !important" :span="8">
        <el-card style="margin:10px 0px;">
          <div slot="header">
            <span>Devize</span>
          </div>
          <el-card style='margin:5px 0px 5px 0px'>
            <div slot="header">
              <span>Alarma alerta devize</span>
              <el-button @click="save_interval" style="float: right; padding: 6px 12px; " type="success" plain round
                size="large"> Salveaza </el-button>
            </div>
            <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;padding:8px">
              <el-form style="width:100%" label-position="top" :model="Interval" :inline="false" :rules="rules_interval"
                label-width="100%" ref='my-form-interval' @submit.prevent="save_interval" size="mini">
                <el-row>
                  <el-form-item label="Interval (secunde)" prop="Interval">
                    <el-input-number style="width:100%" v-model="Interval.numarSecunde" :min="1"
                      :step="5"></el-input-number>
                  </el-form-item>
                </el-row>
              </el-form>

              <el-upload class="upload-demo" drag :limit="1" :action="base_url + '/admin/upload/upload_audio_file'"
                :on-preview="handlePreview" :on-remove="handleRemove" :on-success="handleSuccess"
                :on-error="handleError" :file-list="Documente">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Trage fisier-ul sau <em>click pentru a incarca</em></div>
              </el-upload>
            </div>

          </el-card>
          <el-card style="margin:10px 0px;">
            <div slot="header">
              <div slot="header">
                <span>Sef service pe deviz</span>
                <el-button @click="save_supervizor_pe_devize" style="float: right; padding: 6px 12px; " type="success"
                  plain round size="large"> Salveaza </el-button>
              </div>
            </div>
            <el-form style="width:100%" label-position="top" :model="formSupervizorPeDevize" :inline="false"
              :rules="rules_supervizor_pe_devize" label-width="100%" ref='my-form-supervizor'
              @submit.prevent="save_supervizor_pe_devize" size="mini">
              <el-row>
                <el-form-item label="Supervizor" prop="SupervizorPeDevize">
                  <el-select v-model="formSupervizorPeDevize.SupervizorPeDevize" placeholder="Supervizor"
                    style="width: 240px">
                    <el-option v-for="item in supervizorPeDevizeOptions" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-row>
            </el-form>

          </el-card>
        </el-card>
      </el-col>
      <el-col class="coloana" style="width:100% !important" :span="8">
        <el-card style="margin:5px 0px 5px 0px">
          <div slot="header">
            <span>Observatii generale deviz</span>
            <el-button @click="save_observatii_deviz" style="float: right; padding: 6px 12px;" type="success" plain
              round size="large">
              Salveaza
            </el-button>
          </div>
          <div style="display:flex;align-items:center;padding:8px">
            <div style="display:flex;flex-direction:column;gap:12px;width:100%">
              <div v-for="(tag, index) in observatiiTags" :key="tag" class="tag-container"
                style="display:flex;align-items:center;gap:8px;justify-content:space-between">
                <el-checkbox v-model="tag.acceptaCantitate" size="small">
                  Accepta cantitate
                </el-checkbox>
                <el-input-number v-if="tag.acceptaCantitate" v-model="tag.cantitateMaxima" :min="0" size="small"
                  placeholder="Cantitate maxima" style="width:200px"></el-input-number>
                <el-tag style="flex:1; display:flex;justify-content:space-between;align-items:center" closable
                  :disable-transitions="false" @close="handleClose(tag)">
                  {{ tag.text }}
                </el-tag>
              </div>
              <div>
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="mini"
                  @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput"
                  icon="el-icon-plus"></el-button>
              </div>
            </div>
          </div>
        </el-card>
        <el-card style="margin:5px 0px 5px 0px">
          <div slot="header">
            <span>Motive penalizare</span>
            <el-button @click="save_motive_penalizare" style="float: right; padding: 6px 12px;" type="success" plain
              round size="large">
              Salveaza
            </el-button>
          </div>
          <div style="padding:8px">
            <div style="display:flex;flex-direction:column;gap:12px;width:100%">
              <div v-for="tag in motivePenalizareTags" :key="tag" class="tag-container">
                <el-tag style="width:100%; display:flex;justify-content:space-between;align-items:center" closable
                  :disable-transitions="false" @close="handleCloseMotive(tag)">
                  {{ tag }}
                </el-tag>
              </div>

              <div>
                <el-input class="input-new-tag" v-if="inputMotiveVisible" v-model="inputMotiveValue"
                  ref="saveMotiveTagInput" size="mini" @keyup.enter.native="handleInputConfirmMotive"
                  @blur="handleInputConfirmMotive"></el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInputMotive"
                  icon="el-icon-plus"></el-button>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";


export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {

      Setari: { SeLucreazaLV: '', SeLucreazaS: '', SeLucreazaD: '', OraStartLV: '', OraStopLV: '', OraStartS: '', OraStopS: '', OraStartD: '', OraStopD: '' },
      Interval: { numarSecunde: "" },
      Results: [],
      base_url: '',
      base_url_no_index: '',
      rules_sms: {
        Mesaj: [{ required: true, message: 'Campul este obligatoriu' }],
        Reminder: [{ required: true, message: 'Campul este obligatoriu' }],
        Reminder2: [{ required: true, message: 'Campul este obligatoriu' }],
      },
      Documente: [],
      rules: {
        // DurataProgramare:  [ { required: true, message: 'Campul este obligatoriu' } ],
        // SeLucreazaLV:      [ { required: true, message: 'Campul este obligatoriu' } ],
        // SeLucreazaS:      [ { required: true, message: 'Campul este obligatoriu' } ],
        // SeLucreazaD:      [ { required: true, message: 'Campul este obligatoriu' } ],
      },
      rules_interval: {
        Interval: [{ required: false, message: 'Campul este obligatoriu', trigger: 'blur' }],
      },
      rules_supervizor_pe_devize: {
        SupervizorPeDevize: [{ required: false, message: '', trigger: 'blur' }],
      },
      formSupervizorPeDevize: {
        SupervizorPeDevize: null,
      },
      observatiiTags: [],
      inputVisible: false,
      inputValue: '',
      supervizorPeDevizeOptions: [],
      motivePenalizareTags: [],
      inputMotiveVisible: false,
      inputMotiveValue: '',
      cache_mecanici: null,
      cache_pauze_mecanici: null,
      cache_program: null,
    };
  },
  methods: {
    async get_info() {
      var response = await this.post("admin/setari/index");

      this.Setari = response.Setari;
      if (this.Setari.NumeAlarmaDevize && this.Setari.NumeAlarmaDevizeHost) {
        this.Documente = [
          {
            name: this.Setari.NumeAlarmaDevizeHost,
            svName: this.Setari.NumeAlarmaDevize,
            url: this.base_url_no_index + 'assets/doc_audio/' + this.Setari.NumeAlarmaDevize
          }
        ];

        if (response.supervizorPeDevizeOptions) {
          this.supervizorPeDevizeOptions = response.supervizorPeDevizeOptions;
        }
        if(response.cache_mecanici){
          this.cache_mecanici = response.cache_mecanici;
        }else{
          this.cache_mecanici = null;
        }

        if(response.cache_pauze_mecanici){
          this.cache_pauze_mecanici = response.cache_pauze_mecanici;
        }else{
          this.cache_pauze_mecanici = null;
        }

        if(response.cache_program){
          this.cache_program = response.cache_program;
        }else{
          this.cache_program = null;
        }
      } else {
        this.Documente = [];
      }

      this.Interval.numarSecunde = this.Setari.IntervalAlarmaDevize
      this.formSupervizorPeDevize.SupervizorPeDevize = this.Setari.SupervizorPeDevize

    },

    handleCloseMotive(tag) {
      this.motivePenalizareTags.splice(this.motivePenalizareTags.indexOf(tag), 1);
    },

    showInputMotive() {
      this.inputMotiveVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveMotiveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirmMotive() {
      if (this.inputMotiveValue) {
        // Verificam sa nu existe deja duplicat
        if (!this.motivePenalizareTags.includes(this.inputMotiveValue)) {
          this.motivePenalizareTags.push(this.inputMotiveValue);
        }
      }
      this.inputMotiveVisible = false;
      this.inputMotiveValue = '';
    },

    async get_motive_penalizare() {
      try {
        this.motivePenalizareTags = [];
        const response = await this.post("admin/setari/get_motive_penalizare");

        if (response.motive) {
          this.motivePenalizareTags = response.motive;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async save_motive_penalizare() {
      try {
        const jsonMotive = JSON.stringify(this.motivePenalizareTags);

        const response = await this.post("admin/setari/save_motive_penalizare", {
          data: jsonMotive
        });

        this.$message({
          type: 'success',
          message: 'Motivele de penalizare au fost salvate cu succes'
        });
      } catch (error) {
        console.error(error);
        this.$message({
          type: 'error',
          message: 'A intervenit o problema in salvarea motivelor!'
        });
      }
    },
    handleClose(tag) {
      this.observatiiTags.splice(this.observatiiTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      if (this.inputValue) {
        this.observatiiTags.push({
          text: this.inputValue,
          acceptaCantitate: false,
        });
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    async get_observatii_deviz() {
      try {
        this.observatiiTags = [];
        const response = await this.post("admin/setari/get_observatii_deviz");

        if (response.observatii) {
          response.observatii.forEach((obs) => {
            this.observatiiTags.push({
              text: obs['observatie'],
              acceptaCantitate: obs['accepta_cantitate'] ?? false,
              cantitateMaxima: obs['cantitate_maxima'] ?? null
            });
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    async save_observatii_deviz() {
      try {
        let jsonObservatiiArray = [];

        this.observatiiTags.forEach((tag) => {
          const obj = {
            observatie: tag.text,
            accepta_cantitate: tag.acceptaCantitate,
            cantitate_maxima: tag.acceptaCantitate ? tag.cantitateMaxima : 0
          };
          jsonObservatiiArray.push(obj);
        });

        jsonObservatiiArray = JSON.stringify(jsonObservatiiArray);

        const response = await this.post("admin/setari/save_observatii_deviz", {
          data: jsonObservatiiArray
        });

        // Mesaj de succes
        this.$message({
          type: 'success',
          message: 'Observatiile au fost modificate cu succes'
        });

      } catch (error) {
        console.error(error);
        this.$message({
          type: 'error',
          message: 'A intervenit o problema in salvarea observatiilor!'
        });
      }
    },


    save: async function () {
      this.$refs['my-form'].validate(async (valid) => {
        if (valid) {
          var save_response = await this.post("admin/setari/save", { Setari: this.Setari });
          if (save_response.Raspuns) {
            this.$notify({
              title: 'Succes',
              message: 'Modificarile au fost salvate!',
              type: 'success',
            });
          } else {
            this.$notify({
              title: 'Eroare',
              message: 'A aparut o problema - modificarile nu au fost salvate!',
              type: 'error',
            });
          }
        }
      });
    },
    async save_interval() {
      try {
        this.$refs['my-form-interval'].validate(async (valid) => {
          if (valid) {
            const response_interval = await this.post("admin/setari/save_interval", { Interval: this.Interval });
            if (response_interval.Success) {
              this.$notify({
                title: 'Succes',
                message: response_interval.SuccessMessage,
                type: 'success',
              });
            } else {
              this.$notify({
                title: 'Eroare',
                message: response_interval.ErrorMessage,
                type: 'error',
              });
            }
          }
        });
      } catch (error) {
        console.error(error)
        this.$message({ type: 'error', message: 'A intervenit o problema in salvarea intervalului!' });
      }
    },

    async save_supervizor_pe_devize() {
      try {
        this.$refs['my-form-supervizor'].validate(async (valid) => {
          if (valid) {
            const response_supervizor = await this.post("admin/setari/save_supervizor_pe_devize", { SupervizorPeDevize: this.formSupervizorPeDevize.SupervizorPeDevize });
            if (response_supervizor.Success) {
              this.$notify({
                title: 'Succes',
                message: response_supervizor.SuccessMessage,
                type: 'success',
              });
            } else {
              this.$notify({
                title: 'Eroare',
                message: response_supervizor.ErrorMessage,
                type: 'error',
              });
            }
          }
        });
      } catch (error) {
        console.error(error)
        this.$message({ type: 'error', message: 'A intervenit o problema in salvarea supervizorului pe devize!' });
      }
    },
    handlePreview(previewData) {
      var audio = new Audio(previewData.url);
      audio.play();
    },
    async handleRemove(removeData) {
      try {
        const response = await this.post("admin/upload/delete_audio_file", { svName: removeData.svName })
        if (response.Success) {
          this.$message({ type: 'success', message: response.SuccessMessage });
        } else {
          this.$message({ type: 'error', message: response.ErrorMessage });
        }
      } catch (error) {
        console.error(error)
        this.$message({ type: 'error', message: 'A intervenit o problema in stergerea fisierului audio!' });
      }
    },
    handleSuccess(response) {
      if (response.Success) {
        this.Documente = [
          {
            name: response.NumeDocHost,
            svName: response.NumeDocSv,
            url: this.base_url_no_index + 'assets/doc_audio/' + response.NumeDocSv
          }
        ];
        this.$message({ type: 'success', message: response.SuccessMessage });
      } else {
        this.$message({ type: 'error', message: response.ErrorMessage });
      }
    },
    handleError() {
      console.log("Error")
    },
  },


  async mounted() {
    if (!this.$has_right('Management')) {
      this.$router.push("/no-rights");
      return;
    }
    if (window.location.href.includes("localhost") || window.location.href.includes("dev")) {
      this.base_url = settings.BASE_URL;
      this.base_url_no_index = settings.BASE_URL_NO_INDEX;
    } else {
      this.base_url = settings.BASE_URL_PROD;
      this.base_url_no_index = settings.BASE_URL_NO_INDEX_PROD;
    }

    this.get_info();
    await this.get_observatii_deviz();
    await this.get_motive_penalizare();
  },
};
</script>

<style lang="less" scoped>
.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  /* Permite să treacă pe rândul următor */
  gap: 10px;
  /* Distanță între tag-uri */
}

.el-tag {
  flex-basis: calc(100%);
  /* 3 tag-uri pe rând */
  text-align: center;
}

.input-new-tag {
  width: 100%;
  vertical-align: bottom;
}

.main-page {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;

  @media (min-width: 768px) {
    flex-direction: column;
    align-items: center;

  }

  @media(min-width: 1025px) {
    flex-direction: row;
    align-items: flex-start;
  }
}

.commands {
  font-size: 14px;
  opacity: 0.3;
}

.butoane {
  width: 100%;

}

.commands-btn-area {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;

  .el-button {
    margin: 5px 0;
    width: 40%;
    font-size: 14px;
  }
}

.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .main-page {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .coloana {
      width: 95%;
    }
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .butoane {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;

    .el-button {
      width: 100%;
      margin: 0;
    }
  }
}
</style>
